


























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent, computed } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockList from '@/components/BlockList.vue'

@Component
class SectionList extends mixins(SectionCore) {
  @Prop() readonly list: ReadonlyArray<any> = []
  @Prop() readonly coverEagle: boolean = false
}

export default defineComponent({
  name: 'SectionList',
  components: {
    SectionBasic,
    BlockList,
  },
  props: SectionList.options.props,
  setup(props) {
    const isContacts = computed(() => {
      return (
        props.list &&
        Array.isArray(props.list) &&
        !!props.list.find((item) => item.value)
      )
    })

    return {
      isContacts,
    }
  },
})
